import * as z from "zod";
import { PublishedShopperAgentSettingsSchema } from "./get-published-shopper-agent-settings";

/** Draft tree if one exists, otherwise published. For editor surfaces. */
export const getDraftShopperAgentSettings = {
  name: "getDraftShopperAgentSettings" as const,
  input: z.object({}),
  output: z.object({
    settings: PublishedShopperAgentSettingsSchema.nullable(),
  }),
};
